import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/home/Group 408@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-3c245880"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footerInfo-container" }
const _hoisted_2 = { class: "introduce-container global-container" }
const _hoisted_3 = { class: "introduce-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_0
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "address" }, " 地址：广州市番禺区华腾路华创产业园总部西塔3B11楼01 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iphone" }, "电话：13326445858", -1))
const _hoisted_7 = { class: "qr-code" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "蓝得微信公众号", -1))
const _hoisted_11 = { class: "item" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "蓝得管家微信号", -1))
const _hoisted_14 = { class: "introduce-right" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copyright-container global-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "copyright" }, " Copyright © 2020-2024 广州市蓝得生命科技有限公司 版权所有 "),
  /*#__PURE__*/_createElementVNode("div", { class: "filings" }, "粤公网安备 44030502008138号")
], -1))

import { reactive,getCurrentInstance } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'FooterInfo',
  setup(__props) {

const instance = getCurrentInstance();
const baseUrl = instance?.appContext.config.globalProperties.$baseUrl;
const introduceData = reactive([
  {
    title: "首页",
    sections: ["企业简介", "发展历程", "产品与服务"],
  },
  {
    title: "产品介绍",
    sections: ["鱼缸", "鱼池", "配件"],
  },
  {
    title: "数字化平台",
    sections: ["大数据分析", "私域管理", "精准服务"],
  },
  {
    title: "定制化服务",
    sections: [
      "服务内容",
      "部分案例",
      "定制流程",
      "服务优势",
      "客户反馈和推荐",
    ],
  },
   {
    title: "联系我们",
    sections: [
      "公司地址",
      "加入我们",
      "合作联系",
    
    ],
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              class: "image-qr",
              src: _unref(baseUrl) + 'home/qr1.png'
            }, null, 8, _hoisted_9),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              class: "image-qr",
              src: _unref(baseUrl) + 'home/qr2.png'
            }, null, 8, _hoisted_12),
            _hoisted_13
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(introduceData, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.title
          }, [
            _createElementVNode("h2", null, _toDisplayString(item.title), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sections, (section) => {
                return (_openBlock(), _createElementBlock("li", { key: section }, _toDisplayString(section), 1))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    _hoisted_15
  ]))
}
}

})